module.exports = __webpack_public_path__ + "static/bunnyEars-92ba0726309c697c985e27c9a544bced.jpg";